module.exports = __webpack_public_path__ + "static/media/thumbnail-budget.2c7f97ce.jpg";